import { translation_file } from "../main.js";
export const translation = {
	methods: {
		trans(slug) {
			// return slug
			if (Number.isInteger(slug) && slug > 1600000000000) {
				let d = new Date(slug)
				return d.toLocaleDateString('de-DE', { year: '2-digit', month: '2-digit', day: '2-digit' })
				//return d.getDate() + "." + (d.getMonth() + 1) + "." + d.getFullYear();
			} else {
				// return slug
				return translation_file[slug] ? translation_file[slug] : slug
				// return translation_file[slug] ? slug + " : " + translation_file[slug] : slug
			}
		}
	}
}